export default __webpack_public_path__ + "static/media/twilio-toolbox.537f86a3.svg";